import { Accessibility } from "@/icons/accessibility"
import { Wheel } from "@/icons/wheel"
import { DefaultIcon } from "@/icons/default";
import type { IconItem, WidgetConfig } from "../types/widget"
import { AssistIcon } from "@/icons/assist";

export const ICON_LIBRARY: IconItem[] = [
  { id: "default", icon: DefaultIcon},
  { id: "accessibility", icon: Accessibility},
  { id: "wheel", icon: Wheel},
  { id: "assist", icon: AssistIcon},
]

export const POSITION_OPTIONS = [
  { value: "top-left", label: "Top Left" },
  { value: "top-right", label: "Top Right" },
  { value: "bottom-left", label: "Bottom Left" },
  { value: "bottom-right", label: "Bottom Right" },
]

export const TEXT_ALIGNMENT_OPTIONS = [
  { value: "left", label: "Left" },
  { value: "center", label: "Center" },
  { value: "right", label: "Right" },
]

export const DEFAULT_WIDGET_CONFIG: WidgetConfig = {
  status: {
    mobile: true,
    desktop: true,
  },
  iconId: "default",
  iconSize: 48,
  label: "Accessibility widget",
  heading: "Accessibility menu",
  position: {
    mobile: "bottom-right",
    desktop: "bottom-right",
  },
  language: {
    default: "en",
    selected: [],
  },
  margins: {
    desktop: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    },
    mobile: {
      top: 20,
      bottom: 20,
      left: 20,
      right: 20,
    },
  },
  primaryColor: "#1863DC",
  keyboard: {
    enabled: false,
    shortcut: 'alt+a',
  },
  modules: {
    color: {
      darkContrast: { enabled: true },
      lightContrast: { enabled: true },
      highContrast: { enabled: true },
      highSaturation: { enabled: true },
      lowSaturation: { enabled: true },
      monochrome: { enabled: true },
    },
    content: {
      adjustFontSizing: { enabled: true },
      highlightTitle: { enabled: true },
      highlightLinks: { enabled: true },
      dyslexicFont: { enabled: true },
      letterSpacing: { enabled: true },
      lineHeight: { enabled: true },
      fontWeight: { enabled: true },
      textAlign: { enabled: true },
    },
    navigation: {
      readingGuide: { enabled: true },
      pauseAnimations: { enabled: true },
      bigCursor: { enabled: true },
    },
    statement: {
      enabled: false,
      url: "",
      displayInWidget: false,
      generatedDate: "",
      formData: {
        companyName: "",
        businessEmail: "",
        website: "",
        wcagStandard: "WCAG 2.2 Level AA",
        conformanceStatus: "fully-conformant",
      },
    },
    profiles: {
      enabled: true,
    },
    pageRead: {
      enabled: true,
    },
    muteSounds: {
      enabled: true,
    },
  },
}

// Legacy export for backward compatibility
export const DEFAULT_SETTINGS = DEFAULT_WIDGET_CONFIG
